(() => {
  if (window.__biotaneGlobalAtcFeedbackBound) return;

  const script = document.currentScript || document.querySelector('script[data-biotane-atc-feedback]');
  if (!script) return;

  const sfxEnabled = script.dataset.sfxEnabled === 'true';
  const hapticEnabled = script.dataset.hapticEnabled === 'true';
  const sfxUrl = script.dataset.sfxUrl || '';
  const volume = Math.min(1, Math.max(0, (Number(script.dataset.sfxVolume) || 0) / 100));
  const hapticMs = Math.min(80, Math.max(10, Number(script.dataset.hapticMs) || 25));

  let atcSound = null;

  if (sfxEnabled && sfxUrl) {
    try {
      atcSound = new Audio(sfxUrl);
      atcSound.preload = 'auto';
      atcSound.volume = volume;
      atcSound.load();
    } catch (error) {
      atcSound = null;
    }
  }

  function getAddToCartButton(target) {
    if (!(target instanceof Element)) return null;

    const button = target.closest(
      'button[name="add"], input[type="submit"][name="add"], .product-form__submit, [data-add-to-cart]'
    );

    if (!button) return null;

    const form = button.form || button.closest('form[action*="/cart/add"]');
    const isExplicitAddButton =
      button.matches('button[name="add"], input[type="submit"][name="add"], .product-form__submit, [data-add-to-cart]');

    if (!form && !isExplicitAddButton) return null;

    if (form) {
      const action = form.getAttribute('action') || '';
      if (action && !action.includes('/cart/add')) return null;
    }

    return button;
  }

  function isUnavailable(button) {
    return Boolean(
      button.disabled ||
      button.matches('[disabled]') ||
      button.getAttribute('aria-disabled') === 'true'
    );
  }

  function playFeedback() {
    if (hapticEnabled && typeof navigator.vibrate === 'function') {
      try {
        navigator.vibrate(hapticMs);
      } catch (error) {}
    }

    if (!atcSound) return;

    try {
      atcSound.pause();
      atcSound.currentTime = 0;
      atcSound.volume = volume;
      const playPromise = atcSound.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(() => {});
      }
    } catch (error) {}
  }

  function handlePointerDown(event) {
    if (typeof event.button === 'number' && event.button !== 0) return;
    const button = getAddToCartButton(event.target);
    if (!button || isUnavailable(button)) return;
    playFeedback();
  }

  function handleKeyDown(event) {
    if (event.key !== 'Enter' && event.key !== ' ') return;
    const button = getAddToCartButton(event.target);
    if (!button || isUnavailable(button)) return;
    playFeedback();
  }

  window.__biotaneGlobalAtcFeedbackBound = true;
  document.addEventListener('pointerdown', handlePointerDown, { passive: true, capture: true });
  document.addEventListener('keydown', handleKeyDown, { passive: true, capture: true });
})();
